module.exports = __webpack_public_path__ + "static/media/kn.b0fd5e10.svg";